// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.release-comments-tab {
  padding: 1.5rem 0.5rem;
}
.release-comments-tab .comments-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.release-comments-tab .comments-header h4 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
}
.release-comments-tab .comments-header .comments-icon {
  color: #757575;
}
.release-comments-tab .no-permission-message {
  color: #757575;
  font-style: italic;
  padding: 1rem 0;
}
.release-comments-tab .comments-loading {
  display: flex;
  justify-content: center;
  padding: 2rem 0;
}
.release-comments-tab .comment-textarea {
  width: 100%;
}
.release-comments-tab .comment-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.5rem;
}
.release-comments-tab .inline-spinner {
  display: inline-block;
  margin-right: 0.5rem;
}
.release-comments-tab .comments-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.release-comments-tab .comment-thread {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 1rem;
}
.release-comments-tab .comment-thread:last-child {
  border-bottom: none;
}
.release-comments-tab .comment-item {
  display: flex;
  gap: 0.75rem;
  padding: 0.5rem 0;
}
.release-comments-tab .comment-avatar .avatar-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
  color: #9e9e9e;
}
.release-comments-tab .comment-content {
  flex: 1;
}
.release-comments-tab .comment-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.release-comments-tab .comment-author {
  font-weight: 600;
}
.release-comments-tab .author-role-badge {
  font-size: 0.75rem;
  font-weight: 400;
  color: #616161;
  background: #eeeeee;
  border-radius: 4px;
  padding: 0.1rem 0.4rem;
  margin-left: 0.25rem;
}
.release-comments-tab .comment-date {
  font-size: 0.8rem;
  color: #9e9e9e;
}
.release-comments-tab .edited-badge {
  font-size: 0.75rem;
  color: #9e9e9e;
  display: flex;
  align-items: center;
  gap: 0.15rem;
}
.release-comments-tab .edited-badge .edited-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.release-comments-tab .resolution-status-badge,
.release-comments-tab .resolution-status-select {
  margin-left: auto;
  font-size: 0.8rem;
  border-radius: 4px;
  padding: 0.1rem 0.5rem;
}
.release-comments-tab .resolution-status-badge.status-open,
.release-comments-tab .resolution-status-select.status-open {
  background: #fff3e0;
  color: #e65100;
}
.release-comments-tab .resolution-status-badge.status-adopted,
.release-comments-tab .resolution-status-select.status-adopted {
  background: #e8f5e9;
  color: #2e7d32;
}
.release-comments-tab .resolution-status-badge.status-closed,
.release-comments-tab .resolution-status-select.status-closed {
  background: #eceff1;
  color: #455a64;
}
.release-comments-tab .comment-text {
  margin: 0.5rem 0;
  white-space: pre-wrap;
  word-break: break-word;
}
.release-comments-tab .comment-actions-bar {
  display: flex;
  gap: 0.5rem;
}
.release-comments-tab .replies-container {
  margin-left: 2.5rem;
  margin-top: 0.5rem;
  border-left: 2px solid #e0e0e0;
  padding-left: 1rem;
}
.release-comments-tab .empty-comments {
  text-align: center;
  padding: 2rem 0;
  color: #757575;
}
.release-comments-tab .empty-comments .empty-icon {
  font-size: 40px;
  width: 40px;
  height: 40px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
